import { CapitalAccountView } from "@/features/S2Dashboard";

export default function CapitalAccountPage() {
  return <CapitalAccountView />;
}
